define('container/argResolvers/CommandArgResolver',['underscore', 'bluebird', './ParamArgResolver'], function(_, Promise, ParamArgResolver) {

    'use strict';

    function CommandArgResolver(commandServiceId, dispatcherServiceId, definitionPrefix) {
        this.commandServiceId = commandServiceId;
        this.dispatcherServiceId = dispatcherServiceId;
        this.definitionPrefix = definitionPrefix;
    }

    CommandArgResolver.prototype.canResolveArg = function(argDefinition) {
        return argDefinition.substring(0, this.definitionPrefix.length) === this.definitionPrefix;
    };

    CommandArgResolver.prototype.resolveArg = function(argDefinition, extensionApi) {

        var parts = _.map(_.tail(argDefinition.split(':')), function(part) {

            if (ParamArgResolver.prototype.canResolveArg(part)) {
                return ParamArgResolver.prototype.resolveArg(part, extensionApi);
            }

            return part;
        });

        return Promise.all(
            [
                extensionApi.container.get(this.commandServiceId),
                extensionApi.container.get(this.dispatcherServiceId)
            ].concat(parts)
        ).spread(function(Command) {
            var DispatcherWithParts = _.partial.apply(_, _.tail(arguments));
            var Partial = _.partial(Command, new DispatcherWithParts());
            Partial.prototype = Command.prototype;
            return Partial;
        });
    };

    return CommandArgResolver;
});

